import { Component, Input } from "@angular/core";

import type { DriveViewerPresentationFacade } from './drive-viewer.presentation-facade';

type DrivePreviewViewPort = Pick<DriveViewerPresentationFacade,
  'closePreview' | 'currentPreviewItem' | 'displayName' | 'getItemIcon'
  | 'getItemIconClass' | 'getPreviewError' | 'getPreviewSafeUrl' | 'getPreviewText'
  | 'isFramePreview' | 'isPreviewLoading' | 'isRefreshingTree' | 'isTextPreview'
  | 'nextPreview' | 'previewIndex' | 'previewOpen' | 'prevPreview' | 'translate'
  | 'visibleItems'>;

@Component({
  selector: "app-drive-viewer-preview",
  templateUrl: "./drive-viewer-preview.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class DriveViewerPreviewComponent {
  @Input({ required: true }) view!: DrivePreviewViewPort;
}
